module.exports = __webpack_public_path__ + "media/images/icons/rooms/bed-2p-water-fea45435c23177abe2c70a4e33b37b11.svg";